import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { CONTACT_EMAIL, WHATSAPP_NUMBER } from '../config/api_config';

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <div className="footer-brand">
            <img src="/haseela_logo.png" alt="Haseela" />
            <span>{t.brand}</span>
          </div>
          <p>{t.footer.tagline}</p>
        </div>

        <div>
          <h3>{t.footer.links}</h3>
          <ul>
            <li><Link to="/">{t.nav.home}</Link></li>
            <li><Link to="/features">{t.nav.features}</Link></li>
            <li><Link to="/plus">{t.nav.plus}</Link></li>
            <li><Link to="/pricing">{t.nav.pricing}</Link></li>
            <li><Link to="/about">{t.nav.about}</Link></li>
            <li><Link to="/demo">{t.nav.demo}</Link></li>
            <li><Link to="/privacy-policy">{t.footer.privacy}</Link></li>
            <li><Link to="/delete-account">{t.footer.delete}</Link></li>
          </ul>
        </div>

        <div>
          <h3>{t.footer.contact}</h3>
          <ul className="contact-list">
            <li>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer">
                <Phone size={16} /> +{WHATSAPP_NUMBER}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT_EMAIL}`}>
                <Mail size={16} /> {CONTACT_EMAIL}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {year} Haseela — {t.brand}. {t.footer.rights}</p>
      </div>
    </footer>
  );
}
